export default "__VITE_ASSET__Ck7KUxtm__"